import { useEffect } from "react";
import { useKitFoldersData } from "../data/use-kit-folders-data";

export const DEFAULT_CHAT_FOLDER_NAME = "Chat Files";

export function useDefaultFolder(
  groupUuid: string | null,
  kitUuid: string | null,
  name: string,
  options?: { autoCreate?: boolean },
) {
  const { folders, createFolder, isCreatingFolder } = useKitFoldersData(
    groupUuid,
    kitUuid,
  );
  const autoCreate = options?.autoCreate ?? false;

  const folderUuid = folders.find((f) => f.name === name)?.uuid;

  async function createDefaultFolder() {
    if (folderUuid) {
      return folderUuid;
    }

    const folder = await createFolder({
      name,
    });

    if (!folder) {
      throw Error("creation of default folder failed");
    }

    return folder.uuid;
  }

  // Auto-create folder when autoCreate is true and folder doesn't exist
  useEffect(() => {
    if (
      autoCreate &&
      !folderUuid &&
      groupUuid &&
      kitUuid &&
      !isCreatingFolder
    ) {
      createDefaultFolder().catch((error) => {
        console.error("Failed to auto-create chat folder:", error);
      });
    }
  }, [autoCreate, folderUuid, groupUuid, kitUuid]);

  return {
    folderUuid,
    createDefaultFolder,
  };
}
